export function getCurrentWeekRange() {
    const now = new Date();
    const currentDay = now.getDay();
    const distanceToMonday = currentDay === 0 ? 6 : currentDay - 1;

    // Create new Date objects to avoid mutation issues
    const monday = new Date(now);
    monday.setDate(now.getDate() - distanceToMonday);

    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    return {
        start: monday,
        end: sunday,
        startISO: formatDateISO(monday),
        endISO: formatDateISO(sunday),
        label: formatWeekLabel(monday, sunday)
    };
}

function formatDateISO(d: Date) {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

function formatWeekLabel(start: Date, end: Date) {
    const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

    const sDay = start.getDate();
    const sMonth = months[start.getMonth()];
    const eDay = end.getDate();
    const eMonth = months[end.getMonth()];

    if (sMonth === eMonth) {
        return `Semana del ${sDay} al ${eDay} de ${sMonth}`;
    }
    return `Semana del ${sDay} de ${sMonth} al ${eDay} de ${eMonth}`;
}
